module.exports={ALL_COUNTRIES:"Todos los países"};